export default __webpack_public_path__ + "static/media/IL.b4fdd9d4.svg";